module.exports = {
	"name": "ชื่อกลุ่ม",
	"deleteConfirmText": "ทำการลบกลุ่ม",
	"dressOwner": "กลุ่มเจ้าของชุด"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/group.json
// module id = 837
// module chunks = 1